import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { api } from "../lib/api";
import Seo from "../components/Seo";
import { Reveal } from "../components/Reveal";

export default function Programs() {
  const [programs, setPrograms] = useState([]);

  useEffect(() => {
    api.get("/programs").then(({ data }) => setPrograms(data)).catch(() => {});
  }, []);

  return (
    <>
      <Seo title="Programlar" description="Bilgece Atölye, Ebeveynlik, Öğretmenlik Akademisi, Matematik, Liderlik ve Bilgelik Pedagojisi programları." />
      <section className="pt-36 pb-16 bg-brand-green text-brand-offwhite grain relative overflow-hidden">
        <div className="container-narrow px-6 lg:px-10">
          <p className="text-xs uppercase tracking-[0.25em] text-brand-gold font-semibold mb-4">Bilgece Ekosistemi</p>
          <h1 className="font-serif text-4xl md:text-6xl font-light">Programlar</h1>
          <p className="text-brand-offwhite/75 mt-5 max-w-2xl leading-relaxed">Her biri Bilgelik Pedagojisi™ temeline dayanan, ihtiyaca göre tasarlanmış öğrenme ve yaşam programları.</p>
        </div>
      </section>

      <section className="section-pad bg-brand-offwhite">
        <div className="container-narrow grid grid-cols-1 md:grid-cols-2 gap-8">
          {programs.map((p, i) => (
            <Reveal key={p.id} delay={(i % 2) * 0.1}>
              <Link to={`/programlar/${p.slug}`} data-testid={`program-card-${p.slug}`}
                className="group block h-full bg-brand-cream border border-brand-gold-light/40 rounded-sm overflow-hidden transition-transform duration-300 hover:-translate-y-1.5 hover:border-brand-gold">
                <div className="h-52 overflow-hidden">
                  <img src={p.cover_image} alt={p.name} loading="lazy" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
                </div>
                <div className="p-8">
                  <span className="text-xs uppercase tracking-[0.2em] text-brand-gold font-semibold">{p.audience}</span>
                  <h2 className="font-serif text-3xl text-brand-green mt-2">{p.name}</h2>
                  <p className="text-brand-text/70 text-sm mt-3 leading-relaxed">{p.tagline}</p>
                  <span className="inline-flex items-center gap-2 mt-5 text-brand-green font-semibold text-sm">
                    İncele <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
                  </span>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </section>
    </>
  );
}
